import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../../app.constant';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { BatchService } from 'src/app/shared/services/batch.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { SubjectService } from 'src/app/shared/services/subject.service';
import { Router } from "@angular/router";
import {MatSnackBar} from '@angular/material';



import { Program } from 'src/app/shared/class/program';
@Component({
  selector: 'app-uploadmark',
  templateUrl: './uploadmark.component.html',
  styleUrls: ['./uploadmark.component.css']
})

export class UploadmarkComponent implements OnInit {
  batches:any;
    selectedFile: File = null;
    errorMessage:any;
    uploadMarksForm:FormGroup;
    programs:any;
 
    module:any;
    modules:any;
    post :any;
    data:any;
    examYear:any;
    subjects:any;
    httpResponseMessage:any;

   
    selectedProgram:Program = new Program (1,'ABC','asd','sadasdsa');
    program:any=null;
    FK_ProgramID:any=null;
    PK_ProgramID:any=null;
    
  constructor(
    private formbuilder:FormBuilder,
    private _batchservice:BatchService,
    private _programservice:ProgramService,
    private _moduleservice:ModuleService,
    private _subjectservice:SubjectService,
    private _uploadservice:UploadService,
    private snackBar: MatSnackBar,
    private router: Router) { }

    ngOnInit() {
      this.uploadMarksForm =this.formbuilder.group( {
       'FK_BatchID':['', Validators],
       'FK_ProgramID':['', Validators],
       'FK_ModuleID':['', Validators],
       'FK_SubjectID':['', Validators],
       'ExamSection':['', Validators],
       'MarkType':['', Validators],
       'ExamYear':['', Validators],
       
       'FileUpload1':[''],
        })
        this.getAllProgram();
       // this.getAllBatch();
       
     }

     

     onFileSelected(event) {
      this.selectedFile = <File> event.target.files[0];
      this.uploadMarksForm.get('FileUpload1').setValue(this.selectedFile);
    }





 getAllProgram() :void  {
      this._programservice.getAllProgram(AppSettings.API_ENDPOINT+AppSettings.GetAllProgram).subscribe(
        data => {  this.programs=data;
                },
                error => this.errorMessage = <any>error)
  }

  getModuleByProgramID(PK_ProgramID) :void  {
    this.PK_ProgramID=PK_ProgramID;
    this.getBatchByProgramID(PK_ProgramID);
    this._moduleservice.getAllModule(AppSettings.API_ENDPOINT+AppSettings.GetAllModule).subscribe(
    data =>
      {
        this.module=data;
        this.modules= this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
   },
   error => this.errorMessage = <any>error)
  }
  
  getBatchByProgramID(PK_ProgramID) :void  {
  var o={
        PK_ProgramID:PK_ProgramID}
        this.post=JSON.stringify(o);
        this._batchservice.GetBatchByProgramID(AppSettings.API_ENDPOINT+AppSettings.GetBatchByProgramID, this.post).subscribe(
            data => {
                    this.batches=data;
                    // this.batches= this.batch.filter((item) => item.FK_ProgramID == PK_ProgramID);
                     },
            error => this.errorMessage = <any>error)
  }

  // getAllBatch() :void  {
  //   this._batchservice.getAllBatch(AppSettings.API_ENDPOINT+AppSettings.GetAllBatch).subscribe(
  //    data => {    this.batches=data;
  //      },
  //    error => this.errorMessage = <any>error)
  // }

  getSubjectByProgramIDModuleID(PK_ModuleID):void{
      var o={PK_ModuleID:PK_ModuleID,FK_ProgramID:this.PK_ProgramID}
       this.post=JSON.stringify(o);
       this._subjectservice.getSubjectbyProgramID(AppSettings.API_ENDPOINT+AppSettings.GetSubjectByParam,this.post).subscribe(
         data => {
             this.subjects=data;
            // this.setCompanies();
                   },
        error => this.errorMessage = <any>error)
       }

       uploadMarks(post) :void  {
       const formdata = new FormData();
       formdata.append('FileUpload1',this.uploadMarksForm.get('FileUpload1').value);
       formdata.append('FK_BatchID',this.uploadMarksForm.get('FK_BatchID').value);
       formdata.append('FK_ProgramID',this.uploadMarksForm.get('FK_ProgramID').value);
       formdata.append('FK_ModuleID',this.uploadMarksForm.get('FK_ModuleID').value);
       formdata.append('FK_SubjectID',this.uploadMarksForm.get('FK_SubjectID').value);
       formdata.append('ExamSection',this.uploadMarksForm.get('ExamSection').value);
       formdata.append('MarkType',this.uploadMarksForm.get('MarkType').value);
       formdata.append('ExamYear',this.uploadMarksForm.get('ExamYear').value);

        this._uploadservice.postMarksFile(AppSettings.API_ENDPOINT+AppSettings.UploadMarksExcel,formdata).subscribe(
          data => {
           this.httpResponseMessage=data;
           this.httpResponseMessage="Marksheet  Uploaded...."

           this.openSnackBar(this.httpResponseMessage,'');
           this.uploadMarksForm.reset();
            },
          error => {
                  console.log(error.error);
                  this.httpResponseMessage=error.error;
          } )
         
          this.openSnackBar(this.httpResponseMessage,'');
          this.router.navigate(['/uploadmark']);
        }

        durationInSeconds = 2;
        openSnackBar(message: string, action: string) {
          this.snackBar.open(message,action ,{
            duration: 2000,
            verticalPosition: 'bottom'
          });
          }


}
